import * as app from './app';
import * as watermark from './watermark';

export default { app, watermark };
